import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getAllAnvaeVasilehNaghleyeh = createAsyncThunk(
  'AnvaeVasilehNaghleyeh/GetAllAnvaeVasilehNaghlieh',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.NoeVasilehNaghlieh.GetAllAnvaeVasilehNaghleyeh}`,
    });
  }
);
